const defaults = {
  path: {
    root: '/'
  },
  sessionStorage: {
    personalDataAgreement:  'agreed_with_the_processing_of_personal_data',
    requiredAgreement:      'agreement_is_required',
    certificateToken:       'certificate_token',
    certificateReservation: 'certificate_reservation',
    savedReservationCode:   'saved_reservation_code'
  },
  functions: {
    open:      'kaishi',
    close:     'chushi',
    reference: 'shokai'
  },
  enum: {
    printed_status: {
      printed:   '印刷済',
      unprinted: '未印刷'
    },
    reservation_type: {
      use: {
        text:  '使用開始',
        style: 'badge-primary'
      },
      disuse: {
        text:  '使用中止',
        style: 'badge-danger'
      }
    },
    user_relationship_type: {
      1: '本人',
      2: '家族',
      3: '家主',
      4: '管理会社',
      5: 'その他'
    },
    tel_type: {
      1: '自宅',
      2: '携帯',
      3: '会社',
      4: 'その他'
    },
    payoff_method: {
      1: '納付書',
      2: '口座振替'
    },
    payment_method: {
      1: '納付書',
      2: '口座振替'
    }
  },
  form_properties: {
    // 予約番号
    reservationCode: {
      name:  'reservationCode',
      label: '予約番号',
      func:  'cert'
    },
    // 日付
    openDate: {
      name:  'openDate',
      label: '使用開始日',
      func:  'open'
    },
    closeDate: {
      name:  'closeDate',
      label: '使用中止日',
      func:  'close'
    },
    // お客様番号
    watertap: {
      name:  'watertapCode',
      label: 'お客様番号',
      func:  'close'
    },
    // ご使用者
    applicantNameKana: {
      name:  'applicantNameKana',
      label: 'ご使用者名（フリガナ）',
      func:  'open,close'
    },
    applicantName: {
      name:  'applicantName',
      label: 'ご使用者名（漢字等）',
      func:  'open,close'
    },
    agentRelationshipType: {
      name:  'agentRelationshipType',
      label: 'ご使用者とのご関係',
      func:  'open,close'
    },
    agentName: {
      name:  'agentName',
      label: '本人以外の関係者のお名前',
      func:  'open,close'
    },
    agentRelationshipDetail: {
      name:  'agentRelationshipDetail',
      label: 'ご使用者との具体的な関係',
      func:  'open,close'
    },
    email: {
      name:  'email',
      label: 'メールアドレス',
      func:  'open,close,cert'
    },
    emailDouble: {
      name:  'emailDouble',
      label: 'メールアドレス（確認）',
      func:  'open,close'
    },
    contactTelType: {
      name:  'contactTelType',
      label: '日中に連絡可能な電話番号の区分',
      func:  'open,close'
    },
    contactTel: {
      name:  'contactTel',
      label: '日中に連絡可能な電話番号',
      func:  'open,close'
    },
    contactTelCompany: {
      name:  'contactTelCompany',
      label: '日中に連絡可能な電話番号の会社名・所属名',
      func:  'open,close'
    },
    // 精算方法
    payoffMethod: {
      name:  'payoffMethod',
      label: '精算方法',
      func:  'close'
    },
    // 入居先
    openPostalcode: {
      name:  'openPostalcode',
      label: 'ご使用の住所の郵便番号',
      func:  'open'
    },
    openPrefecture: {
      name:  'openPrefecture',
      label: 'ご使用の住所の都道府県',
      func:  'open'
    },
    openCity: {
      name:  'openCity',
      label: 'ご使用の住所の市区町村',
      func:  'open'
    },
    openAddress: {
      name:  'openAddress',
      label: 'ご使用の住所の町名番地',
      func:  'open'
    },
    openBuilding: {
      name:  'openBuilding',
      label: 'ご使用の住所の建物（アパート）名',
      func:  'open'
    },
    openRoomNo: {
      name:  'openRoomNo',
      label: 'ご使用の住所の棟・部屋番号',
      func:  'open'
    },
    openAddressTelType: {
      name:  'openAddressTelType',
      label: 'ご使用住所の電話番号の区分',
      func:  'open'
    },
    openAddressTel: {
      name:  'openAddressTel',
      label: 'ご使用住所の電話番号',
      func:  'open'
    },
    openAddressTelCompany: {
      name:  'openAddressTelCompany',
      label: 'ご使用住所の電話番号の会社名・所属名',
      func:  'open'
    },
    // 転居先
    nextPostalcode: {
      name:  'nextPostalcode',
      label: '転居先の住所の郵便番号',
      func:  'close'
    },
    nextPrefecture: {
      name:  'nextPrefecture',
      label: '転居先の住所の都道府県',
      func:  'close'
    },
    nextCity: {
      name:  'nextCity',
      label: '転居先の住所の市区町村',
      func:  'close'
    },
    nextAddress: {
      name:  'nextAddress',
      label: '転居先の住所の町名番地',
      func:  'close'
    },
    nextBuilding: {
      name:  'nextBuilding',
      label: '転居先の住所の建物（アパート）名',
      func:  'close'
    },
    nextRoomNo: {
      name:  'nextRoomNo',
      label: '転居先の住所の棟・部屋番号',
      func:  'close'
    },
    nextAddressTelType: {
      name:  'nextAddressTelType',
      label: '転居先の電話番号の区分',
      func:  'close'
    },
    nextAddressTel: {
      name:  'nextAddressTel',
      label: '転居先の電話番号',
      func:  'close'
    },
    nextAddressTelCompany: {
      name:  'nextAddressTelCompany',
      label: '転居先の電話番号の会社名・所属名',
      func:  'close'
    },
    // 料金支払方法
    closeOpen: {
      name:  'closeOpen',
      label: '給水区域内転居のご使用開始お申込み',
      func:  'close'
    },
    nextOpenDate: {
      name:  'nextOpenDate',
      label: '転居先での使用開始日',
      func:  'close'
    },
    paymentMethod: {
      name:  'paymentMethod',
      label: '料金支払方法',
      func:  'open,close'
    },
    prevWatertapCode: {
      name:  'prevWatertapCode',
      label: '前住所のお客様番号',
      func:  'open'
    },
    directDebitConfirm: {
      name:  'directDebitConfirm',
      label: '口座振替に関するご承諾事項のチェック',
      func:  'open,close'
    },
    // 納付書等発送先
    hasShippingAddress: {
      name:  'hasShippingAddress',
      label: '納付書等発送先の選択肢',
      func:  'open,close'
    },
    shippingCustomerNameKana: {
      name:  'shippingCustomerNameKana',
      label: '納付書等発送先のお名前（フリガナ）',
      func:  'open,close'
    },
    shippingCustomerName: {
      name:  'shippingCustomerName',
      label: '納付書等発送先のお名前',
      func:  'open,close'
    },
    shippingPostalcode: {
      name:  'shippingPostalcode',
      label: '納付書等発送先の郵便番号',
      func:  'open,close'
    },
    shippingPrefecture: {
      name:  'shippingPrefecture',
      label: '納付書等発送先の都道府県',
      func:  'open,close'
    },
    shippingCity: {
      name:  'shippingCity',
      label: '納付書等発送先の市区町村',
      func:  'open,close'
    },
    shippingAddress: {
      name:  'shippingAddress',
      label: '納付書等発送先の町名番地',
      func:  'open,close'
    },
    shippingBuilding: {
      name:  'shippingBuilding',
      label: '納付書等発送先の建物（アパート）名',
      func:  'open,close'
    },
    shippingRoomNo: {
      name:  'shippingRoomNo',
      label: '納付書等発送先の棟・部屋番号',
      func:  'open,close'
    },
    shippingTel: {
      name:  'shippingTel',
      label: '納付書等発送先の電話番号',
      func:  'open,close'
    }
  }
};

export const generate = (overrides) => {
  const config = Object.assign({}, defaults, overrides);
  // path
  config.path = config.path || {};
  config.path.root = config.path.root || '/';
  const { root } = config.path || '/';
  config.path.api = `${root}data/`;
  // open
  config.path.open = `${root}kaishi/`;
  config.path.open_confirm = `${config.path.open}kakunin/`;
  config.path.open_complete = `${config.path.open}kanryo/`;
  // close
  config.path.close = `${root}chushi/`;
  config.path.close_confirm = `${config.path.close}kakunin/`;
  config.path.close_complete = `${config.path.close}kanryo/`;
  // reference / change / cancel
  config.path.reference_certificate = `${root}ninsho/`;
  config.path.reference = `${root}shokai/`;
  config.path.change = `${root}henko/`;
  config.path.change_confirm = `${config.path.change}kakunin/`;
  config.path.change_complete = `${config.path.change}kanryo/`;
  config.path.cancel_complete = `${root}torikeshi/kanryo/`;
  return config;
};
